export default function ProblemCallout() {
  return (
    <section className="py-16 md:py-20" style={{ backgroundColor: '#FFFFFF' }} data-testid="landing-problem">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 text-center">
        <div className="rounded-2xl border-2 p-8 md:p-12" style={{ borderColor: '#D77A52', backgroundColor: '#FBF6EF' }}>
          <p className="text-5xl sm:text-6xl font-black" style={{ color: '#D77A52' }} data-testid="landing-problem-stat">
            1.3 million
          </p>
          <p className="mt-3 text-xl sm:text-2xl font-bold leading-snug" style={{ color: '#5B2D1F' }}>
            Americans visit the ER each year because of harmful drug interactions.
          </p>
          <p className="mt-2 text-xs" style={{ color: '#8B7A6B' }}>
            Source: Agency for Healthcare Research and Quality (AHRQ)
          </p>
          <p className="mt-6 text-lg leading-relaxed" style={{ color: '#6B4A3A' }}>
            Most could be prevented. Heritage Compass gives you the picture before that happens.
          </p>
        </div>
      </div>
    </section>
  );
}
